import React, { useEffect } from 'react'
import { Box, Icon, Typography } from '@mui/material'
import BoxInput from '../../../Common/BoxInput/BoxInput'
import { sendOTPAction, verifyOTPAction } from './../API/Action'
import { useLocation, useNavigate } from 'react-router-dom'
import Lottie from 'lottie-react'
import successLottie from '../../../../utils/Lottie/NewSuccess.json';
import IconReusable from '../../../../components/IconReusable'
import { encryptPassword } from '../../../../v2/Utils/Encryption/NodeForgeEncryption'
import { useDispatch, useSelector } from 'react-redux'
import { LOGIN_METHOD_ENUM, OTP_PURPOSE_ENUM } from '../../Enum';
import { toast } from 'react-toastify'
import { LoginAction } from '../../Login/API/Action'
import { onLoggedIn } from '../../../../v2/Function/onLoggedIn'


const OTPVerify = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [otp, setOtp] = React.useState('');
    const [error, setError] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [verified, setVerified] = React.useState(false);
    const [timer, setTimer] = React.useState(60);
    const [resendDisabled, setResendDisabled] = React.useState(true);
    const mobile_no = location.state?.mobile_no || ''; // Get mobile number from location state, fallback to empty string if not availables
    
    const navigate = useNavigate();
    const OTP_PURPOSE = useSelector((state) => state.authReducer.OTP_PURPOSE);
    const mobile_number = useSelector(state => state.authReducer.mobile);
    const EPIN_SET = useSelector((state) => state.authReducer.EPIN_SET);
    const USER_DATA_FILLED = useSelector(state => state.authReducer.USER_DATA_FILLED);
    const VFC_TOKEN = useSelector(state => state.authReducer.VFC_TOKEN);
    
    const handleRedirection = (epinSet = EPIN_SET, userDataFilled = USER_DATA_FILLED, token) => {
      if (!epinSet) {
        navigate('/epin');
      }else if (!userDataFilled) {
          navigate('/user-details');
      } else { 
        navigate('/');
      }
    }
    const handleBackNavigation = () => {
        if (OTP_PURPOSE === OTP_PURPOSE_ENUM.REGISTER) {
            navigate('/registration');
        } else if (OTP_PURPOSE === OTP_PURPOSE_ENUM.LOGIN) {
            navigate('/login');
        } else if (OTP_PURPOSE === OTP_PURPOSE_ENUM.RESET) {
            navigate('/reset-pin');
        } else {
            navigate('/'); // default fallback
        }
    }
    useEffect(() => {
        if (timer > 0) {
        setResendDisabled(true);
        const interval = setInterval(() => {
            setTimer(prev => prev - 1);
        }, 1000);
        return () => clearInterval(interval);
        } else {
        setResendDisabled(false);
        }
    }, [timer]);

    const handleResend = async() => {
        if (!resendDisabled) {
            setTimer(60);
            setResendDisabled(true);
            const payload = { 
                mobile_number: mobile_number,
                purpose: OTP_PURPOSE_ENUM.LOGIN
            };
            const { error, message } = await sendOTPAction(payload);
            setLoading(false);
            if (!error) {
                toast.success(message);
            } else {
                toast.error(message);
            }
        }
    };
    const VerifyOtp = async (otp) => {
        setLoading(true);
        setError('');
        setVerified(false);
        const payload = { 
            mobile_number: mobile_number,
            otp: encryptPassword(otp),
            purpose: OTP_PURPOSE
        };
        const { data, error, message } = await verifyOTPAction(payload);
        setLoading(false);
        if (!error) {
            setError('');
            dispatch({ type: 'SET_VFC_TOKEN', payload: data.vfc_token });
            if (OTP_PURPOSE === OTP_PURPOSE_ENUM.REGISTER) {
                dispatch({ type: 'SET_USER_DATA_FILLED', payload: data?.user_data_filled });
                dispatch({ type: 'SET_EPIN_SET', payload: data?.is_epin_set });
                setTimeout(() => {
                    handleRedirection(data?.is_epin_set, data?.user_data_filled);
                }, 4000);
            }
            setVerified(true);
        } else {
            setError(message);
            setVerified(false);
        }
    };
    const handleLogin = async () => {
        setLoading(true);
        const payload = {
            mobile_number: mobile_number,
            vfc_token: VFC_TOKEN,
            method: LOGIN_METHOD_ENUM.OTP
        };
        const { data, error, message } = await LoginAction(payload);
        setLoading(false);
        if (!error) {
            localStorage.setItem('token', data.token);
            dispatch({ type: 'SET_USER_DATA_FILLED', payload: data.user_data_filled });
            dispatch({ type: 'SET_EPIN_SET', payload: data.is_epin_set });
            if(data?.user_data_filled === true && data?.is_epin_set === true){
                await onLoggedIn({
                    data: {
                        token: data.token
                    },
                    navigate,
                    dispatch,
                    toast
                });
            }
            handleRedirection(data?.is_epin_set, data?.user_data_filled, data?.token);
        } else {
            toast.error(message);
        }
    };
    useEffect(() => {
        if ( OTP_PURPOSE === OTP_PURPOSE_ENUM.LOGIN && VFC_TOKEN) {
            handleLogin();
        }else if (OTP_PURPOSE === OTP_PURPOSE_ENUM.RESET && VFC_TOKEN) {
            navigate('/epin');
        }
    },[VFC_TOKEN, OTP_PURPOSE])
    
  return (
    <Box sx={{ display:"flex", flexDirection:"column", gap: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconReusable 
                name="ArrowBack" 
                size={24} 
                color="#666" 
                onClick={handleBackNavigation}
            />
            <Typography variant='h1' sx={{ color: '#666666' }}>
                {OTP_PURPOSE === OTP_PURPOSE_ENUM.REGISTER ? 'Register' : OTP_PURPOSE === OTP_PURPOSE_ENUM.RESET ? 'Enter OTP' : 'Login'}
            </Typography>
        </Box>
        <Box sx={{ display:"flex", flexDirection:"column", gap: 2 }}>
            <Typography variant='h2'>Please enter OTP sent to Mobile Number {mobile_no}</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <BoxInput
                    length={4}
                    value={otp}
                    onChange={val => {
                    setOtp(val);
                        if (val.length === 4) {
                            VerifyOtp(val);
                        } else {
                            setVerified(false);
                            setError('');
                        }
                    }}
                    type="text"
                    showEyeIcon={false}
                    error={!!error}
                    disabled={loading || verified}
                />
                {verified && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Lottie
                        animationData={successLottie}
                        loop={false}
                        style={{ width: 24, height: 24 }}
                        // onComplete={handleRedirection}
                    />
                    <Typography variant='body1'>
                        Verified
                    </Typography>
                    </Box>
                )}
                </Box>
                {error && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <IconReusable name="ErrorFilled" size={20} color="#CC0000" />
                    <Typography variant='body1' sx={{ color: '#CC0000', }}>
                    {error}
                    </Typography>
                </Box>
                )}
            </Box>
            <Box sx={{ display:"flex",alignItems:"center", gap: 0.5 }}>
                <Typography variant='body1'>
                Didn't receive the OTP?
                </Typography>
                <Typography
                    variant='labelD'
                    component="span"
                    sx={{color: resendDisabled ? '#D9D9D9' : '#995A00', cursor: resendDisabled ? 'not-allowed' : 'pointer'}}
                    onClick={handleResend}
                    disabled={resendDisabled}
                >
                Resend
                </Typography>
                <Typography variant='body1'>
                OTP in  {`00:${timer.toString().padStart(2, '0')}`}
                </Typography>
            </Box>
        </Box>
    </Box>
  )
}

export default OTPVerify